import { action, observable } from 'mobx';

export enum FlagType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export interface FlagAction {
  content: string | JSX.Element;
  onClick: () => void;
}

export interface Flag {
  actions?: FlagAction[];
  description?: string | JSX.Element;
  id?: string;
  shouldAutoDismiss?: boolean;
  title: string;
  type: FlagType;
}

export type InternalFlag = Flag & {
  id: string;
  shouldAutoDismiss: boolean;
};

export default class FlagStore {
  @observable flags: InternalFlag[] = [];

  @action
  addFlag(flag: Flag): InternalFlag {
    const { id = Date.now().toString(), shouldAutoDismiss = true } = flag;
    const newFlag: InternalFlag = { id, shouldAutoDismiss, ...flag };

    this.flags = [newFlag, ...this.flags.filter(x => x.id !== newFlag.id)];
    return newFlag;
  }

  @action
  removeFlag(flagId: string) {
    this.flags = this.flags.filter(x => x.id !== flagId);
  }
}
